import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { Component, OnInit, Input } from '@angular/core';
import { BottomsheetShared } from '../shared/bottomsheet-shared';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { GenerateShared } from '../shared/generate-shared';

@Component({
  selector: 'app-ios-bottomsheet',
  templateUrl: './ios-bottomsheet.component.html',
  styleUrls: ['./ios-bottomsheet.component.scss'],
})
export class IosBottomsheetComponent implements OnInit {
  @Input() input: IosBottomsheetInputModel;

  constructor(
    private bottomsheetShared: BottomsheetShared,
    private planService: PlanService,
    private generateShared: GenerateShared,
    private snackBarService: SnackBarService
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.animateUp();
    }, 100);
  }

  closeMoreOptions() {
    document.getElementById('iosBottomsheet').style.transform =
      'translate(0, 0)';
    setTimeout(() => {
      this.bottomsheetShared.closeIosBottomsheet();
    }, 300);
  }

  animateUp() {
    document.getElementById('iosBottomsheet').style.transform =
      'translate(0, -100%)';
  }

  buttonSelected(title: string) {
    if (title === 'گزارش ...') {
      this.bottomsheetShared.openReportBottomsheet();
    } else if (title === 'اشتراک گذاری') {
      let newVariable: any;
      newVariable = window.navigator;
      if (newVariable && newVariable.share) {
        newVariable
          .share({
            url: this.bottomsheetShared.shareLink,
          })
          .catch((e) => {
            this.snackBarService.showSnackBar('خطا در اشتراک گذاری');
          });
      } else {
        // this.snackBarService.showSnackBar('اشتراک گذاری در جست‌و‌جوگر شما پشتیبانی نمیشود');
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = this.bottomsheetShared.shareLink;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.snackBarService.showSnackBar('لینک پست کپی شد');
      }
    } else if (title === 'بله') {
      if (this.input.type === 'pending') {
        this.bottomsheetShared.pendingFoodsConfirm();
      } else {
        this.planService.goToMain();
        setTimeout(() => {
          this.planService.goToSecondTabMyPlan();
        }, 300);
        // this.generateShared.isCanceling = true;
        // this.planService.goToGenerate();
      }
    }
  }
}

export class IosBottomsheetInputModel {
  constructor(
    public actionButtonTitles: string[],
    public dismissTitle: string,
    public title?: string,
    public type?: string
  ) {}
}
